import { v4 as uuidv4 } from 'uuid'
import { operationsAjax } from '../ajax/OperationsAjax'
import { PagedResult } from '../DTOs/Common/PagedResult'
import { StoppageCalc } from '../DTOs/Stoppage/StoppageCalc'
import { queryClient } from '../queryClient'
import { store } from '../state/store'
import { computeShiftId } from './computeShiftId'
import { enqueue } from './queueOps'
import { isOnlineNow } from './connectivity'
import { mayQueueOffline, offlineRefusal } from './offlineWrites'
import { sendDirect } from './directSave'

function currentShiftId(): number {
  const { selectedDate, selectedShift } = store.getState().shift
  return computeShiftId(selectedDate, selectedShift)
}

function provisionalPlantId(operationId: number): number | undefined {
  if (operationId >= 0) return undefined

  for (const [, page] of queryClient.getQueriesData<PagedResult<StoppageCalc>>({
    queryKey: ['dataTable', 'operations', 'stoppageCalcs'],
  })) {
    const match = (page?.data ?? []).find(row => row?.operationId === operationId)
    if (match?.plantId) return match.plantId
  }
  return undefined
}

export const engineHoursMutations = {
  async updateEngineHours(operationId: number, startHours: number | null, endHours: number | null, fuel: number | null) {
    const clientId = uuidv4()
    if (isOnlineNow()) {
      const sent = await sendDirect(() => operationsAjax.updateEngineHours(operationId, startHours, endHours, fuel, clientId))
      if (sent) return sent
    }
    if (!mayQueueOffline()) return offlineRefusal()

    await enqueue({
      clientId,
      entity: 'engineHours',
      operation: 'update',
      shiftId: currentShiftId(),
      entityId: operationId,
      data: {
        operationId,
        startEngineHours: startHours,
        endEngineHours: endHours,
        fuel,
        operationPlantId: provisionalPlantId(operationId),
      },
    })

    return { success: true, data: null }
  },
}
